import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Table, TableColumn } from "../../../components/table";
import IconMdi from "@mdi/react";
import {
  mdiPencilCircle,
  mdiPlusNetworkOutline,
  mdiDelete,
  mdiAccountGroup,
} from "@mdi/js";
import { useState, useEffect } from "react";
import EmptyModel from "../../../components/modal/emptyModal";
//import Input from "../../../components/textfield/input";
import { useHistory } from "react-router";
import axios from "axios";
import { Modal } from "antd";
import { Icon } from "@iconify/react";
import { Input } from "antd";

const Category = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [category, setCategory] = useState<any>([]);

  const [categoryId, setCategoryId] = useState("");
  const [name, setName] = useState<string>("");
  const [code, setCode] = useState<string>("");

  const [type, setType] = useState<string>("");

  const columns = [
    {
      title: "",
    },
    {
      title: "Acronym",
    },
    {
      title: "Category Medical Treatment ",
    },
    {
      title: "Action",
      align: "center",
      colspan: 4,
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getData = () => {
    axios.get(`/product-categories`).then((res) => {
      if (res.data.data) {
        console.log("resss", res.data.data);

        setCategory(res.data.data);
      } else {
        setCategory([]);
      }
    });
  };

  const getDataOne = (id: any) => {
    axios.get(`/product-categories/${id}`).then((res) => {
      let data = res.data;
      setCategoryId(data._id);
      setName(data.name);
      setCode(data.code);
    });
  };

  const creatData = async () => {
    console.log(name);
    try {
      await axios
        .post(`${process.env.REACT_APP_BASE_URL}/product-categories`, {
          code: code,
          name: name,
        })
        .then((res) => {
          setTimeout(() => getData(), 200);
          setIsOpen(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/product-categories/${id}`).then((res) => {
      console.log(res.data);
      setTimeout(() => getData(), 200);
    });
  };

  const updateData = async (id: any) => {
    try {
      await axios
        .patch(`${process.env.REACT_APP_BASE_URL}/product-categories/${id}`, {
          name: name,
          code: code,
        })
        .then((res) => {
          setTimeout(() => getData(), 200);
          setIsOpen(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const setCreat = () => {
    setName("");
    setCode("");
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <HeaderBar title="CATEGORY LIST" />
      <EmptyModel show={isOpen} onClose={onClose} width="650px">
        {type == "create" ? (
          <h5>สร้างประเภทหัตถการ/Create Category Medical Treatment </h5>
        ) : (
          <h5>แก้ไขประเภทหัตถการ/Update Category Medical Treatment </h5>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center  mt-20">
            <label
              style={{
                color: "#5BAEA9",
                marginBottom: 15,
                fontSize: 14,
                fontWeight: 500,
                paddingLeft: 0,
              }}
            >
              ชื่อประเภทหัตถการ/Category Name
            </label>
            <Input
              value={name}
              onChange={(e: any) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className="row justify-center  mt-20">
            <label
              style={{
                color: "#5BAEA9",
                marginBottom: 15,
                fontSize: 14,
                fontWeight: 500,
                paddingLeft: 0,
              }}
            >
              อักษรย่อ/Acronym
            </label>
            <Input
              value={code}
              onChange={(e: any) => {
                setCode(e.target.value);
              }}
            />
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก/Cancel"
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล/Submit"
              onClick={() => {
                categoryId ? updateData(categoryId) : creatData();
              }}
            />
          </div>
        </div>
      </EmptyModel>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="Create Category"
            onClick={() => {
              setCreat();
              setIsOpen(true);
              setType("create");
            }}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {category.map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="10%">{item.code}</TableColumn>
                <TableColumn width="25%">{item.name}</TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item._id);
                      setIsOpen(true);
                      setType("update");
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      color="#5baea9"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() =>
                      history.push(`category/list/${item._id}/jobGroupCategory`)
                    }
                  >
                    <IconMdi path={mdiAccountGroup} size="24" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() =>
                      history.push(`category/list/${item._id}/subcategory`)
                    }
                  >
                    <IconMdi
                      path={mdiPlusNetworkOutline}
                      size="24"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn
                  width="3%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                    // deleteData(item._id);
                  }}
                >
                  <Icon
                    icon="icomoon-free:bin"
                    width="20"
                    height="20"
                    color="#FF6760"
                  />
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default Category;
